<template>
  <div>
    <HeaderGroup></HeaderGroup>
    <div class="full_height full_width">
      <a href="/">
        <img src="../assets/1639745515699209.jpg" style="display:block" class="full_width">
      </a>
    </div>
    <div class="image-container">
      <img src="../assets/index-bg.png" style="height: 155px;width: 100%">
      <div class="text-overlay">
        <h3>执享信息</h3>
        <div style="background: white; height: 2px;width: 54px"></div>
        <div>北京执享信息科技有限公司</div>
      </div>
      <div class="text-next">
        <h3>www.zxtechgroup.com</h3>
        <div>公司网址</div>
      </div>
    </div>

    <div class="index-title">
      <p class="t1">服务提供</p>
      <div style="font-size: 14px; font-weight: lighter;">为您提供专业的数据信息方案！</div>
      <div class="displayF" style="margin-top: 15px">
        <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
      </div>
    </div>


    <div class="grid-container">
      <div v-for="(item, i) in imgData" :key="i" class="grid-item">
        <img-group :img="item"></img-group>
      </div>
    </div>
    <div class="index-institute">
      <div class="index-title">
        <p class="t1" style="color: white;">公司简介</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
      </div>

      <div class="displayF justifyContent">
        <div class="leftbox rightbox" style="color: white; font-size: 14px;">
          我们主要从事于一般项目：技术进出口；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；健康咨询服务（不含诊疗服务）；物联网技术服务；数据处理服务；咨询策划服务；品牌管理；动漫游戏开发；个人互联网直播服务；互联网销售（除销售需要许可的商品）；文化娱乐经纪人服务；租赁服务（不含许可类租赁服务）；广告设计、代理；平面设计；社会经济咨询服务；广告制作；组织文化艺术交流活动；信息咨询服务（不含许可类信息咨询服务）；信息技术咨询服务；广告发布；文艺创作。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：互联网信息服务；第二类增值电信业务等...
        </div>
        <img class="leftbox rightbox" src="../assets/1639745746692680.jpg">
      </div>
    </div>
    <div class="index-news">
      <div class="index-title">
        <p class="t1" style="color: black;">行业咨询</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
      </div>

      <div  class="grid-item">
      <div v-for="(item, i) in contentImgData" :key="i" style="margin: 0 5% 0 5%" >
        <industry-consulting :img="item">
        </industry-consulting>
      </div>
      </div>
    </div>
    <div>
      <bottom>
      </bottom>
    </div>
  </div>
</template>

<script>
import HeaderGroup from "@/components/HeaderGroup.vue";
import ImgGroup from "@/components/ImgGroup.vue";
import IndustryConsulting from "@/components/IndustryConsulting.vue";
import Bottom from "@/components/Bottom.vue";

export default {
  name: 'Index',
  components: {Bottom, IndustryConsulting, ImgGroup, HeaderGroup},
  props: {
    msg: String
  },

  data() {
    return {
      imgData: [
        {img: require("@/assets/faxing.png"), name: "游戏发行"},
        {img: require("@/assets/shujuwajue.jpg"), name: "数据挖掘"},
        {img: require("@/assets/ruanjiankaifa.jpg"), name: "软件开发"},
        {img: require("@/assets/rengongzhineng.jpg"), name: "人工智能"}
      ],
      contentImgData: [
        {
          img: require("@/assets/biaoge.jpg"),
          title: "赋能煤炭货运数字化的这一年，大数据都看到了什么？",
          content: "  根据5个省份的月度煤炭运输量数据表现趋势来看，内蒙古、山西、陕西三地均在2020年9月开始出现上涨趋势，主要是受供暖季对煤炭需求骤增的影响。   下面我们将重点放在内蒙古，从公路运输重量、煤炭运价、运煤车辆数等多个维度来看下内蒙古2020年整体的..."
        },    {
          img: require("@/assets/1_1.jpg"),
          title: "内蒙古走访见闻：数字化技术到底给煤炭流通带来什么？",
          content: "  「以前一天最多跑一趟，去了电厂还得排队几个小时甚至一整天，而现在 G7 数字甩箱模式推出应用后，问题迎刃而解。我拉活也更省心、省事，一天可以跑两三趟，收入也比以前增加了。」   「你能相信吗？这么大的运转中心，包括智能磅房在内的多个环节实现了无人..."
        },    {
          img: require("@/assets/1_2.jpg"),
          title: "小程序实现物流信息（进度展示）",
          content: " 其实可以把整体拆分成两大块，分别是最上方：物流详情，下方：物流信息；最上方实现起来比较简单，就不多赘述，主要跟大家说一下下面的实现思路，下面我又将它们分成了左边和右边两个大块，左边是进度的竖线展示，右边是物流文字信息展示，其中有两个点需要注意，首先..."
        },
      ]

    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full_width {
  width: 100%;
}

.full_height {
  height: 100%;
}

.index-institute {
  padding: 0 0 70px 0;
  background: #0c4270
}

.index-news {
  padding: 10px 0 70px 0;
  background: #e3e3e3
}


.image-container {
  position: relative;
  display: inline-block;
}

.index-institute .leftbox {
  color: #fff;
  width: 30%;
  float: left;
  line-height: 30px;
  padding: 10px 30px;
}

.text-overlay {
  position: absolute;
  top: 50%; /* 垂直居中 */
  left: 30%; /* 水平居中 */
  transform: translate(-50%, -50%); /* 微调位置 */
  color: white; /* 文字颜色 */
  padding: 10px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  width: 30%;
}

.grid-container-contentImgData{
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 两列 */
  gap: 20px; /* 项目间距 */
  max-width: 1000px; /* 控制整体宽度 */
  margin: 0 auto; /* 水平居中 */
  padding: 20px; /* 内边距 */
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列 */
  grid-template-rows: repeat(2, 1fr); /* 两行 */
  gap: 20px; /* 项目间距 */
  max-width: 1000px; /* 控制整体宽度 */
  margin: 0 auto; /* 水平居中 */
  padding: 20px; /* 内边距 */
}




.grid-item {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* 防止内容溢出 */
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
}

.text-next {
  position: absolute;
  top: 50%; /* 垂直居中 */
  left: 60%; /* 水平居中 */
  transform: translate(-50%, -50%); /* 微调位置 */
  color: white; /* 文字颜色 */
  padding: 10px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  width: 30%;
}

h3 {
  font-size: 40px;
  padding-bottom: 15px;
  position: relative;
  margin: 0px;
  font-weight: normal
}

.index-title {
  padding: 60px 0;
  text-align: center;
  align-items: center;
  position: relative;
  line-height: 30px
}

.displayF {
  display: flex;
  justify-content: center;
}

.t1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px
}


</style>
